import React from 'react';
import FacebookIcon from './Facebook';
import YoutubeIcon from './Youtube';
import InstagramIcon from './Instagram';


const Socials = () => {
  return (
    <div className="menu-socials">
      <a
        href="https://www.facebook.com/customartagencja/"
        rel="noopener"
        target="_blank"
        className="menu-socials__link"
      >
        <FacebookIcon />
      </a>
      <a
        href="https://www.youtube.com/channel/UCetpXU-6AoO_WA1IL1A_6_Q"
        rel="noopener"
        target="_blank"
        className="menu-socials__link"
      >
        <YoutubeIcon />
      </a>
      <a
        href="https://www.instagram.com/customart_agencja/"
        rel="noopener"
        target="_blank"
        className="menu-socials__link"
      >
        <InstagramIcon />
      </a>
    </div>
  )
};

export default Socials;



// WEBPACK FOOTER //
// ./src/components/MainHeader/Socials.js